import { AccountObject, IAccountObjectArgs } from "../account-object/account-object.model";

export interface IRestrictedAccountObjectArgs extends IAccountObjectArgs {
    accessGroup?: string;
}

const defaults = {
    accessGroup: undefined
} as IRestrictedAccountObjectArgs;

export abstract class RestrictedAccountObject extends AccountObject {
    accessGroup: string;

    constructor(data?: IRestrictedAccountObjectArgs) {
        super({...defaults, ...data} as any);
    }
}



// WEBPACK FOOTER //
// ./src/vas/business-objects/restricted-account-object/restricted-account-object.model.ts